import axios from "axios";

/**
 * Updates a specific prospect history event.
 * @param {number} eventId - The ID of the event to update.
 * @param {string} [notes] - The new notes content (optional).
 * @param {number} [prospectHistoryEventTypeId] - The ID representing the type of the prospect history event (optional).
 * @returns {Promise<any>} - Resolves with the API response when successful.
 */
const updateEvent = async (
  eventId: number,
  notes?: string,
  prospectHistoryEventTypeId?: number
): Promise<any> => {
  try {
    const payload: Record<string, any> = { Id: eventId };

    if (notes !== undefined) {
      payload.Notes = notes.trim() === "" ? "-" : notes;
    }
    if (prospectHistoryEventTypeId !== undefined) {
      payload.ProspectHistoryEventTypeId = prospectHistoryEventTypeId;
    }

    console.log("DEBUG updateEvent.ts: Sending payload to API:", payload);

    // Make the POST request to the backend endpoint.
    const { data } = await axios({
      method: "POST",
      url: `/api/cantrackv3/UpdateProspectHistoryEvent`,
      headers: { "Content-Type": "application/json;charset=UTF-8" },
      data: { payload },
    });
   
    console.log("DEBUG updateEvent.ts: Event updated successfully:", data);
    return data;
  } catch (error) {
    console.error("DEBUG updateEvent.ts: Error updating event:", error);
    throw error;
  }
};

export default updateEvent;
